import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar/sidebar";
import { ProtectedProvider } from "@/features/auth/_providers/protected-provider";
import { AdminGate, BirdieMonitorSidebar } from "@/features/birdie-monitor";
import { ErrorFallback } from "@/features/shared/error-fallback";
import { StatsigProvider } from "@/features/shared/providers/statsig-provider";

/**
 * Layout of `/birdie`, the admin Birdie monitor (docs/birdie/monitor.md): signed in, an admin (the Birdie server
 * checks the role again on every request), and the monitor's sidebar. No floating Birdie chat here: the pages show
 * other people's conversations with Birdie, and a chat of the viewer's own beside them would confuse the two.
 */
export const Route = createFileRoute("/birdie")({
  component: BirdieMonitorLayout,
});

function BirdieMonitorLayout() {
  return (
    <ProtectedProvider>
      <AdminGate>
        <StatsigProvider>
          <SidebarProvider>
            <BirdieMonitorSidebar />
            <ErrorBoundary
              fallbackRender={({ error }) => <ErrorFallback error={error} />}
            >
              <SidebarInset>
                <Outlet />
              </SidebarInset>
            </ErrorBoundary>
          </SidebarProvider>
        </StatsigProvider>
      </AdminGate>
    </ProtectedProvider>
  );
}
